export default {"src":"/login-app/[GIT_HASH]/_next/static/media/graph_neighbors.ce4f8bda.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};